import { useQuery } from '@tanstack/react-query';

import { getTaxReceipts } from '@sola/proxy-sdk/utils/routes.js';

import { QUERY_KEYS } from '../constants';
import { useReadyForQueries } from './base';

/**
 * Hook to fetch tax receipts.
 */
export const useTaxReceipts = () => {
  const { isReady, globalId } = useReadyForQueries();

  return useQuery({
    queryKey: [QUERY_KEYS.supporterTaxReceipts],
    queryFn: () => getTaxReceipts(globalId!),
    refetchOnWindowFocus: false,
    enabled: isReady,
    staleTime: Infinity,
  });
};
